import produce from 'immer';
import './types';
import {
    SET_SEASON_LEADERS
} from '../actions';

/**
 * @type {SeasonLeadersState}
 */
const initialState = {
    data: null
};

/**
 * @param {SeasonLeadersState} state - The Redux state.
 * @param {SeasonLeadersActions} action - The Redux action.
 * @return {SeasonLeadersState} The updated Redux state.
 */
export const seasonLeadersReducer = ( state = initialState, action ) => {
    return produce( state, draft => {
        switch ( action.type ) {
            case SET_SEASON_LEADERS:
                draft.data = action.payload;
                break;
            default:
                draft;
        }
    } );
};